import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import Root from "./Root";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const sentryDsn =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://c90e3cf298179a9f4fa267e035d5f803@o111140.ingest.us.sentry.io/4512128577241088";

Sentry.init({
  dsn: sentryDsn,
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below:
    // userInfo: false,
    // httpBodies: []
  },
});

// Expose Sentry globally for easy testing via Browser Console DevTools
if (typeof window !== "undefined") {
  window.Sentry = Sentry;
}

const root = createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      // #60f76de8
    />
    <Root />
  </>
);
